import { Injectable } from "@angular/core";
import { ActiveState, EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { PaloggetBrukerRepresentererTo } from "@husbanken/bruker-api";

export interface UserRepresentsState extends EntityState<PaloggetBrukerRepresentererTo>, ActiveState {}

@Injectable({ providedIn: "root" })
@StoreConfig({ name: "userRepresents", idKey: "organisasjonsnummer" })
export class UserRepresentsStore extends EntityStore<UserRepresentsState, PaloggetBrukerRepresentererTo> {
  constructor() {
    super();
  }
}
